import React from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

export default function ForInfluencerMatching() {
  const { t } = useTranslation()
  
  return (
    <Tooltip title={t('campaignCreate.businessInformation.forInfluencerMatching.tooltip')}>
      <div className='bg-[#FFF6ED] border border-[#FFD1A9] h-[22px] flex items-center justify-center px-2 rounded-[11px] w-fit'>
        <div className="text-center justify-start text-[#C4330A] text-xs font-medium font-['DM_Sans'] leading-4">
          {t('campaignCreate.businessInformation.forInfluencerMatching.label')}
        </div>
      </div>
    </Tooltip>
  )
}
